<template>
	<div>
		<div class="homeChar">
			<div class="echartMark"></div>
			<div id="myChart" style="width: 100%; height: 100%;" class="chart"></div>
		</div>
		<div class="homeMid">
			<div class="serDays" @click="goToMine">
				<div class="leftCont">
					<div class="leftImg1"></div>
					<span>我们已为您服务<span>{{timeMes}}</span></span>
				</div>
				<div class="rightArrow"></div>
			</div>
			<a class="contactUs" href='tel://400-810-0504'>
				<div class="leftCont">
					<div class="leftImg2"></div>
					<span>坐席热线</span>
				</div>
				<div class="rightArrow"></div>
			</a>
		</div>
		<div class="homeBto">
			<div class="homeBto01">
				<router-link :to=urlRouters.makeWork>
					<div class="item01Img"></div>
				</router-link>
				<router-link :to=urlRouters.device>
					<div class="item02Img"></div>
				</router-link>
				<router-link :to=urlRouters.assetMes>
					<div class="item03Img"></div>
				</router-link>
				<router-link :to=urlRouters.monitor>
					<div class="item04Img"></div>
				</router-link>
			</div>
			<div class="homeBto02">
				<router-link :to=urlRouters.makeWork><div>我要提单</div></router-link>
				<router-link :to=urlRouters.device><div>设备信息</div></router-link>
				<router-link :to=urlRouters.assetMes><div>资产信息</div></router-link>
				<router-link :to=urlRouters.monitor><div>全局监控</div></router-link>
			</div>
		</div>
	</div>
	

</template>

<script>
	import {_api} from '@/service/interface'
	
	//import echarts from 'echarts'
	//引入基本模板
	let echarts = require('echarts/lib/echarts')
	//引入柱状图组件
	require('echarts/lib/chart/pie')
	//引入提示框和title组件
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	require('echarts/lib/component/graphic')
	require('echarts/lib/component/legend')
	
	export default{
		name:'WcHome',
		props:['args'],
		data(){
			return {
				dataArr:[],
				nameArr:[],
				legendArr:[],
				total:0,
				timeMes:'',
				urlRouters:{
					makeWork:'/editWorksheet',
					device:'/device',
					assetMes:'/asset',
					monitor:'/monitor'
					
				},
				myChart:null
			}
		},
		methods:{
			drawPie(obj){
				//基于准备好的dom，初始化echarts实例
				//绘制图表
				var _this = this;
				var listData = obj.list;
				this.nameArr=listData.map(item=>{
					return item.name
				});
				this.total=obj.total;
				this.myChart.setOption({
					
					title:{
						text: obj.pointName,
						textStyle:{
							color:'#FFFFFF',
							
							
						},
						x:'center',
						top:10
					},
					tooltip:{},
					color:["#EEC626","#27EFED","#2CE734"],
					legend: {
						selectedMode :true,
						show:true,
				        orient: 'horizontal',
				        width:'100%',
				        bottom:10,
				        itemWidth:24,
				        itemHeight:13,
				        data:this.nameArr,
				        textStyle:{
				        	color:'#FFFFFF',
				        	fontFamily:'Microsoft YaHei',
				        	fontSize: 11
				        },
				        formatter: function(name){
				        	let legend=listData.find(item=>{
				        		return item.name==name
				        	})
				        	return `${legend.name} ${legend.value}`
				        }
				    },
					graphic:[
						{
							type: 'text',
				            left: 'center',
				            top: '42%',
				            style: {
				                text:this.total,
				                textAlign:'center',
				                fill:'#FFFFFF',
				                font: '40px Microsoft YaHei'
							},
							onclick: function () {
								setTimeout(()=>{
									_this.$router.push('/index/worksheet?selected=1');
								},20);
							}
						},
						{
							type: 'text',
				            left: 'center',
				            top: '55%',
				            style: {
				                text:'工单总数',
				                textAlign:'center',
				                fill:'#FFFFFF',
				                font: '15px Microsoft YaHei'
							},
							onclick: function () {
								setTimeout(()=>{
									_this.$router.push('/index/worksheet?selected=1');
								},20);
							}
						}
						
					],
					series:[
						{
							name:'安仔远程运维服务',
							type:'pie',
							radius:['50%','55%'],
							center: ['50%', '50%'],
							label:{
								show:false
							},
							labelLine:{
								show:false
							},
							data:obj.list
							
						}
					]
					
				});
				this.myChart.on('legendselectchanged',(params) => {
					let mapOrder={"最新工单":1,"处理中":2,"已解决":3}
					setTimeout(()=>{
						this.$router.push('/index/worksheet?selected='+mapOrder[params.name]);
					},20);
				})
			},
			goToMine(){
				this.$router.push('/index/mine');
			},
			goToWorksheet(){
				this.$router.push('/index/worksheet');
			},
			formatTen(num){//不足10加0
				//return num.toString().padStart(2,"0");
				return num>9?(num+""):("0"+num)
			},
			dateFormat(second){
				 var dd;           
				 second = typeof second === 'string' ? parseInt(second) : second;           
				 if(!second || second < 0){
				 return;           
				 }           
				 //天  
				 dd = second / (24 * 3600) | 0;           
				 dd=this.formatTen(dd);
				 return dd + '天';       
			},
			getServeTime(){
				_api('_point','[2].code',{params:{mark:'getUserBanner'}},res=>{
					this.timeMes=this.dateFormat(res[2].data.onlineTime);
					//console.error('dasdas',this.timeMes)
				},err=>{
					
				})
			}
		},
		mounted:function(el){
			this.getServeTime();
			this.myChart = echarts.init(document.getElementById("myChart"));
			this.drawPie(this.args);
			//this.aab(this.args);
		},
		
	
	}
</script>

<style>
	.contactUs{
		color: #000;
	}
	.homeChar{
		width: 100%;
		height: 350px;
		background-image:linear-gradient(left,#00B5C0,#019BCD);
		background-image: -webkit-linear-gradient(left,#00B5C0,#019BCD);
		display: flex;
		justify-content: center;
		align-items: center;
		position:relative;
	}
	.echartMark{
		position: absolute;
	    width: 230px;
	    height: 230px;
	    background: url(../../assets/images/home_echart_bg.png) no-repeat;
	    background-size: 230px 230px;
	    top: 0;
	    right: 0;
	    bottom: 0;
	    left: 0;
	    margin: auto;
	}
	.homeMid{
		width: 100%;
		height: 101px;
		background: #FFFFFF;
		margin-top: 10px;
		border-top: 1px solid #DCDCDC;
		border-bottom: 1px solid #DCDCDC;
	}
	.serDays{
	    height: 50px;
	    border-bottom: 1px solid #DCDCDC;
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	    justify-content: space-between;
	    padding-left: 15px;
	    padding-right: 15px;
		font-size: 14px;
	}
	.contactUs{
		height: 50px;
	    border-bottom: 1px solid #DCDCDC;
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	    justify-content: space-between;
	    padding-left: 15px;
	    padding-right: 15px;
		font-size: 14px;
	}
	.leftCont{
		display: flex;
		align-items: center;
	}
	.itemImg{width: 25%;}
	.leftImg1{
		width: 24px;
		height:24px;
		background: url(../../assets/images/indexSerImg.png) no-repeat;
		background-size:24px 24px;
		margin-right: 10px;
	}
	.leftImg2{
		width: 24px;
		height:24px;
		background: url(../../assets/images/contactUsImg.png) no-repeat;
		background-size:24px 24px;
		margin-right: 10px;
	}
	.rightArrow{
		width: 6px;
		height: 12px;
		background:url(../../assets/images/rightArrow.png) no-repeat;
		background-size:6px 12px;
	}		
	.homeBto{
		background: #FFFFFF;
		margin-top: 10px;
		border-top: 1px solid #DCDCDC;
		border-bottom: 1px solid #DCDCDC;
	}	
	.homeBto01{
		display: flex;
		height: 80px;
		justify-content: space-evenly;
		align-items: flex-end;
	}
	.homeBto02{
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding-bottom: 18px;
		color: #3B3B3B;
		font-size: 14px;
	}
	.homeBto02 a{
		color: #3B3B3B;
	}
	.item01Img{
		width: 80px;
		height: 70px;
		background: url(../../assets/images/item01Img.png);
		background-size: 80px 80px;
	}
	.item02Img{
		width: 80px;
		height: 70px;
		background: url(../../assets/images/item02Img.png);
		background-size: 80px 80px;
	}
	.item03Img{
		width: 80px;
		height: 70px;
		background: url(../../assets/images/item03Img.png);
		background-size: 80px 80px;
	}
	.item04Img{
		width: 80px;
		height: 70px;
		background: url(../../assets/images/item04Img.png);
		background-size: 80px 80px;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/WcHome.vue